import React, { useEffect, useState } from 'react';

import {
  Button,
  ModalPortal,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Flex,
  Label,
  Span,
  FormGroup
} from '@sopranodesign/pulse-components';

import SubjectSelect from './SubjectSelect';
import Subject from './Subject';
import { useComposer } from '../../hooks/index';

const ComposerSettings = () => {
  const {
    response: { subject },
    subjects,
    dispatch,
    getSubject,
    showSettings
  } = useComposer();

  const [subjectValid, setSubjectValid] = useState(true);

  const subjectConfig = subject
    ? subjects.find(({ subject: config }) => config.type === subject.type)
    : null;

  const Validator = subjectConfig?.Validator || null;

  // Reset validity when there is nothing to validate.
  useEffect(() => {
    if (!Validator) {
      setSubjectValid(true);
    }
  }, [Validator]);

  if (subjects?.length === 0) {
    return null;
  }

  const handleSettingsOpen = () => dispatch({ type: 'OPEN_SETTINGS' });

  const handleSettingsSave = () => dispatch({ type: 'SAVE_SETTINGS' });

  const handleSettingsClose = () => dispatch({ type: 'CLOSE_SETTINGS' });

  const handleSubjectChange = ({ value }) => {
    const subject = getSubject(value);

    dispatch({ type: 'CHANGE_SUBJECT', newSubject: subject.subject });
  };

  const handleSubjectClear = () => {
    dispatch({ type: 'CHANGE_SUBJECT', newSubject: null });
  };

  return (
    <>
      {Validator && (
        <Validator subject={subject} onValidityChange={setSubjectValid} />
      )}
      {!subjectValid && (
        <Span tinyText colour="danger">
          This advanced setting references something that no longer exists.
          Open it to update or clear the setting.
        </Span>
      )}
      <Flex col>
        <Button variant="secondary" onClick={handleSettingsOpen}>
          Advanced settings
        </Button>
      </Flex>
      {showSettings && (
        <ModalPortal>
          <ModalContainer>
            <ModalContent>
              <ModalHeader>Advanced Settings</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label htmlFor="subjects">Data Type</Label>
                  <SubjectSelect
                    id="subjects"
                    value={subject ? subject.type : null}
                    onChange={handleSubjectChange}
                  />
                </FormGroup>
                <Subject />
              </ModalBody>
              <ModalFooter>
                <Flex xSpace>
                  <Button variant="secondary" onClick={handleSubjectClear}>
                    Clear settings
                  </Button>
                  <Button variant="secondary" onClick={handleSettingsClose}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleSettingsSave}>
                    Save
                  </Button>
                </Flex>
              </ModalFooter>
            </ModalContent>
          </ModalContainer>
        </ModalPortal>
      )}
    </>
  );
};

export default ComposerSettings;
